import { Role } from '@/core/components/auth/auth.types'
import { ErrorComponent } from '@/core/components/ErrorComponent'
import { LoadingList } from '@/core/components/LoadingList'
import { getConnections } from '@/core/components/sites/site/site-customization/manage-site/advanced-tab/connectivityQueryOptions'
import { getExternalTaxes } from '@/core/components/sites/site/site-customization/policies/taxAndFeesQueryOptions'
import { redirect } from '@tanstack/react-router'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/_layout/dashboard/sites/$siteId/site-customization/policies/create/tax-and-fees-policy/'
)({
  beforeLoad: ({ context: { auth } }) => {
    if (auth.isExpired()) {
      return
    }
    if (!auth.isAuthenticated) {
      throw redirect({
        to: '/',
      })
    }
    if (
      auth.user?.role === Role['Front-Desk'] ||
      auth.user?.role === Role['Editor'] ||
      auth.user?.role === Role['Blogger']
    ) {
      throw redirect({
        to: '/dashboard',
      })
    }
  },
  loader: ({ context: { queryClient, auth }, params: { siteId } }) => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    const taxes = queryClient.ensureQueryData(
      getExternalTaxes(siteId, auth.token!)
    )
    const connections = queryClient.ensureQueryData(
      getConnections(siteId, auth.token!)
    )

    return { taxes, connections }
  },
  errorComponent: ErrorComponent,
  pendingComponent: LoadingList,
})
